"use strict";

jQuery(document).ready(function ($) {
  $('.cf7mls_next').removeClass('cf7mls_btn').removeClass('action-button').addClass('btn').addClass('btn--brand1');
  $('.cf7mls_back').removeClass('action-button').addClass('btn').addClass('btn--brand2');
  $('.wpcf7-submit').removeClass('wpcf7-submit');
});